import React, { Suspense } from "react";
import {NotificationSettings} from '@rankmi/ats-app'

const index = ({organization}) => {
  
  return (
    <Suspense fallback={""}>
      <NotificationSettings organization={organization}/>
    </Suspense>
  );
};

export default index;
